import RegistreConfig from './_config/registres.routes';
import RegistresRoutes from './_config/registres.config';

// TEXS
import TexsComponent from './components/registres/texs';
import texsInGrid from './components/registres/texs/components/texs-in-grid';
import texsOutGrid from './components/registres/texs/components/texs-out-grid';

//REP
import RepComponent from './components/registres/rep';

// SERVICES
import RegistresService from './services/registres.service';
import DAPsService from '../dap/services/daps.service';

import dapGeoLocFixCallback from './components/dap-geo-loc-fix-callback';

const RegistresModule = 'app.massia.gestion.registres';
angular
	.module(RegistresModule, [])
	.config(RegistreConfig)
	.config(RegistresRoutes)
	.component('texs', TexsComponent)
	.component('texsInGrid', texsInGrid)
	.component('texsOutGrid', texsOutGrid)
	.component('rep', RepComponent)
	.component('dapGeoLocFixCallback', dapGeoLocFixCallback)
	.service('registresService', RegistresService)
	.service('dapService', DAPsService);

export default RegistresModule;
